import React, { FC, useContext } from 'react';

import brasaoHorizontal from 'img/brasao_horizontal_monocromatico_72dpi.png'
import brasao from 'img/brasao_monocromatico_72dpi.png'

// import brasaoSTI from 'img/sti-brasao.png'

import styled from 'styled-components';
import { Spacing } from 'styles/theme/Tema';
import { MenuContext } from '../Menu/Menu';

export const Rodape: FC = () => {
  const context = useContext(MenuContext);
  const imagem = context.compacto ? brasao : brasaoHorizontal;

  return <Footer id="rodape">
    {/* { */}
      {/* <a href="http://sti.ufc.br/"><img src={brasaoSTI} alt="Portal da Superintendência de Tecnologia da Informação" /></a> */}
      <Link href="http://ufc.br/">
        <ImgBrasaoUFC src={imagem} alt="Portal da Universidade Federal do Ceará" />
      </Link>
    {/* } */}
  </Footer>;
}

const Footer = styled.footer`
  background-color: var(--menu-background);
`;

const Link = styled.a`
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
`;

const ImgBrasaoUFC = styled.img`
  max-width: 100%;
  /* width: 250px; */
  height: auto;
  /* margin: ${Spacing.unit/2}px; */
  padding: 1.5em;
  filter: invert(1);
`;